import { render, staticRenderFns } from "./ConstructionProjects.vue?vue&type=template&id=44b896ae&scoped=true"
import script from "./ConstructionProjects.vue?vue&type=script&lang=js"
export * from "./ConstructionProjects.vue?vue&type=script&lang=js"
import style0 from "./ConstructionProjects.vue?vue&type=style&index=0&id=44b896ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b896ae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VChip } from 'vuetify/lib/components/VChip';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSlider } from 'vuetify/lib/components/VSlider';
installComponents(component, {VAutocomplete,VCheckbox,VChip,VContainer,VFlex,VLayout,VSlider})
